import { DiscountValueType } from "@redotech/redo-model/discount";
import {
  DiscountSettings,
  DiscountSettingsType,
} from "@redotech/redo-model/discount/discount-db-parser";
import { upsellCardDefaultText } from "@redotech/redo-model/team";
import { validDiscount } from "./discount-util";

/**
 * Get upsell text based on custom text or discount information
 */
export function getUpsellText(
  upsellText: string | undefined,
  discountSettings: DiscountSettings | undefined,
): string {
  if (upsellText && upsellText !== upsellCardDefaultText) {
    return upsellText;
  }

  if (
    discountSettings &&
    discountSettings.settingsType === DiscountSettingsType.SHOPIFY_BASIC &&
    validDiscount(discountSettings)
  ) {
    return `Shop again, get ${discountSettings.discountValueType === DiscountValueType.PERCENTAGE ? `${discountSettings.discountValueAmount}%` : `$${discountSettings.discountValueAmount}`} off`;
  }

  return upsellCardDefaultText;
}

/**
 * Calculate initial expiration duration for discount countdown
 */
export function getInitialExpirationDuration(
  discountSettings: DiscountSettings | undefined,
): number | undefined {
  if (!discountSettings) {
    return undefined;
  }

  const settings = discountSettings;
  if (!settings) {
    return undefined;
  }

  if (settings.endsAt) {
    const endDate = Temporal.Instant.from(settings.endsAt.toISOString());
    const futureInstant = Temporal.Instant.from(endDate);
    const durationUntilFutureInMs = Temporal.Now.instant()
      .until(futureInstant)
      .total({ unit: "milliseconds" });

    return durationUntilFutureInMs > 0 ? durationUntilFutureInMs : undefined;
  }
  return undefined;
}
